import { render } from "./zhenggaojianyan-news.vue?vue&type=template&id=0fd9619a&scoped=true"
import script from "./zhenggaojianyan-news.vue?vue&type=script&lang=js"
export * from "./zhenggaojianyan-news.vue?vue&type=script&lang=js"

import "./zhenggaojianyan-news.vue?vue&type=style&index=0&id=0fd9619a&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd9619a"]])

export default __exports__